/** @module csi/widget/_svg/ImageReplaceIndicator */
define([
	"dojo/_base/lang",
	"dojo/aspect",
	"dijit/form/Button",
	"csi/comm/PostRequest",
	"csi/html",
	"csi/locale",
	"csi/widget/_svg/util",
	"./_Plugin",
	"./PluginFactory"
], function(lang, aspect, Button, PostRequest, html, locale, svgUtil, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		"class": "csi-link-btn",
		iconClass: "csiActionIcon iconImageReplaceIndicator",
		label: "ImageReplaceIndicator",
		pluginName: "imageReplaceIndicator",
		showLabel: true,
		/** @property {null:boolean} bImageChanged */
		bImageChanged: null,

		/**
		 * Reset plugin cache on "save and finish"
		 */
		postCreate: function() {
			var self = this;
			this.own(
				aspect.after(this.getView(), "save", function(bFinish) {
					if (bFinish) {
						self.resetCache();
					}
				}, true)
			);
			this.inherited(arguments);
		},

		/**
		 *  We enable/disable edit plugin here, making it dependent on indicator state: if indicator is visible - "edit" will be disabled
		 *  @param {boolean} bDisable - disable edit if true
		 */
		setEditDisabled: function(bDisable) {
			var view = this.getView();
			var editPlugin = view.getPlugin("edit");
			editPlugin.set("disabled", bDisable);
			editPlugin.set("title", bDisable ? locale.resource("ImageReviewEdit") : editPlugin.label);
		},

		/**
		 * Detect placeholder changes - return true if changed
		 * @return {boolean}
		 */
		isPlaceholderDataChanged: function() {
			if (this.editor.placeholderDifferenceData) {
				return this.editor.placeholderDataChanged;
			}
			return false;
		},


		/**
		 * Show button only on normal mode and if user has access to edit the revision
		 * Also button is only visible if canvas has Image with successor
		 */
		canShowPlugin: function() {
			const {editMode, view} = this.editor;
			if (view._deferredSvg.isResolved() && view.canEditCanvas() && !editMode) {
				// the ability to replace images is currently only supported on datasheets
				// but we want to be able to edit in this case
				if (!view.isDataSheetCanvas() && !view.isCanvasTemplate() && !view.isTheme() && !view.isProductPresentationLayout()) {
					this.setEditDisabled(false);
					return false;
				}

				// bShow == true means that we have detected image or placeholder changes and plugin should become visible
				let bShow = this.bImageChanged || this.isPlaceholderDataChanged();

				// Detect image changes
				if (this.bImageChanged === null && !this.getView().isCanvasTemplate()) { // Cache server request, only send request once
					this.bImageChanged = false;
					const viewNode = view.getViewNode();
					const nodeUrl = (svgUtil.isNonRevisionCanvas(viewNode)) ? viewNode.$URL : viewNode.__Parent__;
					new PostRequest("SiteAdmin", "CanvasHasImagesWithSuccessor")
						.addParameter("URL", nodeUrl)
						.post({}).then(
							lang.hitch(this, function(res) { // Request successful
								var bImageChanged = this.bImageChanged = res.getReturnValue();
								bShow = bImageChanged || this.isPlaceholderDataChanged();
								html.setVisible(this.domNode, bShow); // Hide/Show button
								this.set("disabled", !bShow);
								this.setEditDisabled(bShow);
							}),
							lang.hitch(this, function(err) { // Error
								console.error("SiteAdmin.CanvasHasImagesWithSuccessor " + err.message);
							})
						);
				} else {
					this.setEditDisabled(bShow);
					return bShow;
				}
			}
			return false;
		},

		/**
		 * Run ImageReplace dialog
		 */
		onClick: function() {
			this.resetCache();
			this.getView().imageReview();
		},

		/**
		 * Reset cache for request "CanvasHasImagesWithSuccessor"
		 */
		resetCache: function() {
			this.bImageChanged = null;
		}
	});
});
